import {HttpClient} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import {PatchUserData, UserData} from '../../interfaces';


@Injectable()
export class UserDataService {
  private http: HttpClient = inject(HttpClient);

  addEmailForUserData(email: string) {
    const body = { contact: email };
    const url = environment.ApiUrl + '/api/v1.0/person/self/contact';

    return this.http.put(url, body);
  }

  requestForConfirmEmail(email: string) {
    const body = { contact: email };
    const url = environment.ApiUrl + '/api/v1.0/person/self/contact/check/init';
    return this.http.post(url, body, { observe: 'response' });
  }

  confirmEmail(email: string, code: string) {
    const url =  environment.ApiUrl + '/api/v1.0/person/self/contact/check';
    const body = {
      verification_code: code,
      contact: email
    }

    return this.http.post(url, body)
  }

  requestForConfirmPhone(phone: string) {
    const body = { contact: phone };
    const url = environment.ApiUrl + '/api/v1.0/person/self/contact/check/init';
    return this.http.post(url, body, { observe: 'response' });
  }

  confirmPhone(phone: string, code: string) {
    const url =  environment.ApiUrl + '/api/v1.0/person/self/contact/check';
    const body = {
      verification_code: code,
      contact: phone
    }

    return this.http.post(url, body)
  }

  getUserData(): Observable<UserData> {
    const url = environment.ApiUrl + '/api/v1.0/person/self';
    return this.http.get<UserData>(url);
  }

  uploadImage(formData: FormData) {
    const url = environment.ApiUrl + '/api/v1.0/person/self/photo';
    return this.http.post(url, formData);
  }

  updateUserData(body: PatchUserData) {
    const url = environment.ApiUrl + '/api/v1.0/person/self';
    return this.http.patch(url, body);
  }

  addPassword(password: string) {
    const body = {password}
    const url = environment.ApiUrl + '/api/v1.0/auth/password';
    return this.http.post(url, body);
  }
}
